import { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader, StatCard } from "@/components/kit";
import { Card } from "@/components/ui/card";
import { Stethoscope, Users, CalendarDays, Library, Dumbbell, DollarSign, BadgeCheck, Clock } from "lucide-react";

export default function AdminDashboard() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/admin/stats").then(({ data }) => setS(data)); }, []);

  return (
    <div>
      <PageHeader title="Painel do Administrador" subtitle="Visão geral da plataforma" />
      {!s ? <div className="h-40 animate-pulse bg-secondary rounded-2xl" /> : (
        <>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
            <StatCard icon={Stethoscope} label="Hipnoterapeutas" value={s.therapists} />
            <StatCard icon={BadgeCheck} label="Profissionais ativos" value={s.active_therapists} accent="accent" />
            <StatCard icon={Clock} label="Aprovações pendentes" value={s.pending_therapists} accent="amber" />
            <StatCard icon={Users} label="Clientes" value={s.clients} accent="slate" />
          </div>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mt-4">
            <StatCard icon={CalendarDays} label="Consultas" value={s.appointments} accent="slate" />
            <StatCard icon={Library} label="Conteúdos" value={s.contents} accent="slate" />
            <StatCard icon={Dumbbell} label="Exercícios" value={s.exercises} accent="slate" />
            <StatCard icon={DollarSign} label="Receita recorrente (MRR)" value={`R$ ${s.mrr.toFixed(2)}`} accent="accent" />
          </div>
          <Card className="mt-6 p-6">
            <h3 className="font-heading text-lg font-medium mb-2">Bem-vinda, Administradora</h3>
            <p className="text-muted-foreground text-sm">
              Gerencie hipnoterapeutas, aprove novos profissionais, configure planos e defina a forma de
              agendamento da plataforma no menu lateral.
            </p>
          </Card>
        </>
      )}
    </div>
  );
}
